export default "__VITE_ASSET__DoaL304C__"